<template>
  <BaseModal
    ref="modalRef"
    :labelled-by="titleId"
    screen-name="signup_get_diga_prescription_support"
  >
    <PrescriptionSupportContent :heading-id="titleId" />
    <template
      v-if="props.showSkip"
      #footer
    >
      <BaseButton
        :text="$t('generic_skip')"
        data-qa="prescription-support-skip"
        @click="handleSkip"
      />
    </template>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue'
import BaseModal from '@shared/components/BaseModal.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import PrescriptionSupportContent from '@eu/app/components/PrescriptionSupportContent.vue'

const props = defineProps({
  showSkip: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['skip'])
const modalRef = ref(null)
const titleId = 'prescription-support-modal-title'

const open = () => modalRef.value.open()
const close = () => modalRef.value.close()
const handleSkip = () => {
  Tracker.trackButtonSelect('skip', 'signup_get_diga_prescription_support')
  close()
  emit('skip')
}

defineExpose({ open, close })
</script>
